"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * custom devtools formatters
 * for better displaying Proxy object
 */

var OriginalProxy = Proxy;
var isEnable = false;

exports.enableProxyFormater = function () {
  if (typeof window === 'undefined') return;
  if (isEnable) return;
  isEnable = true; // track all proxies in weakset (allows GC)

  var proxy_set = new WeakSet();
  window.Proxy = new OriginalProxy(OriginalProxy, {
    construct: function construct(target, args) {
      var proxy = new target(args[0], args[1]);
      proxy_set.add(proxy);
      return proxy;
    }
  });
  window.devtoolsFormatters = [{
    header: function header(obj) {
      try {
        if (!proxy_set.has(obj)) {
          return null;
        }

        return ['object', {
          object: JSON.parse(JSON.stringify(obj))
        }];
      } catch (e) {
        return null;
      }
    },
    hasBody: function hasBody() {
      return false;
    }
  }];
};

exports.disableProxyFormater = function () {
  isEnable = false;
  delete window.devtoolsFormatters;
  window.Proxy = OriginalProxy;
};